import type { SceneConfig, TranscodeTrack } from '@types';
import getPanoVideoUrl from './getPanoVideoUrl';

export type PVideoTrackList = {
  url: string;
  name: string;
  resType: Required<SceneConfig>['defaultResolution'];
}[];

function getPanoViewTrackList({
  transcodeTrack,
  cdnDomain,
  originTrack,
}: {
  transcodeTrack: TranscodeTrack;
  cdnDomain: number;
  /** 原画画质, v5.7.5更新 */
  originTrack?: string;
}): PVideoTrackList {
  const list: PVideoTrackList = [];
  if (originTrack) {
    list.push({
      url: getPanoVideoUrl({ cdnDomain, url: originTrack }),
      name: '原画',
      resType: 0,
    });
  }
  if (transcodeTrack.super?.Status === 'SUCCESS') {
    list.push({
      url: getPanoVideoUrl({ cdnDomain, url: transcodeTrack.super.FileUrl }),
      name: '4K',
      resType: 2,
    });
  }
  if (transcodeTrack.high?.Status === 'SUCCESS') {
    list.push({
      url: getPanoVideoUrl({ cdnDomain, url: transcodeTrack.high.FileUrl }),
      name: '2K',
      resType: 3,
    });
  }
  if (transcodeTrack.standard?.Status === 'SUCCESS') {
    list.push({
      url: getPanoVideoUrl({ cdnDomain, url: transcodeTrack.standard.FileUrl }),
      name: '高清',
      resType: 1,
    });
  }
  return list;
}

export default getPanoViewTrackList;
